import React, {Component} from 'react'
import PropTypes from 'prop-types'
import isEqual from 'lodash/isEqual'
import innerText from 'react-innertext'
import Analytics from '../'

const withAnalyticsOnKeyPress = WrappedComponent =>
  class extends Component {
    static propTypes = {
      input: PropTypes.shape({
        name: PropTypes.string,
        onKeyPress: PropTypes.func
      }).isRequired,
      meta: PropTypes.shape({error: PropTypes.oneOfType([PropTypes.string, PropTypes.bool])}).isRequired,
      label: PropTypes.any,
      exposeValue: PropTypes.bool.isRequired
    }

    static defaultProps = {
      label: '',
      exposeValue: false
    }

    static displayName = `${WrappedComponent.displayName}WithAnalyticsOnKeyPress`

    constructor(props) {
      super(props)

      this.analytics = new Analytics(props.analytics)
    }

    componentDidUpdate(prevProps) {
      if (
        prevProps.analytics &&
        !isEqual(prevProps.analytics.contexts, this.props.analytics.contexts)
      ) {
        this.analytics = new Analytics(this.props.analytics)
      }
    }

    onKeyPress = event => {
      if (event.key === 'Enter') {
        const {
            input: {name, value},
            meta: {touched, error},
            label,
            exposeValue
          } = this.props,
          field = {
            name,
            label: innerText(label),
            error: touched && error || null
          }

        // Expose user input user when needed
        if (exposeValue) {
          Object.assign(field, {value: `${value}`})
        }

        this.analytics.event(field)
      }
    }

    render() {
      const {input, ...props} = this.props

      return (
        <WrappedComponent input={{...input, onKeyPress: this.onKeyPress}} {...props}/>
      )
    }
  }

export default withAnalyticsOnKeyPress
